import { withBemMod } from '@bem-react/core';

import { cnTag } from '../Tag.cn';

import './Tag_view_outline.css';

export type WithViewOutlineProps = {
    view?: 'outline';
};
export const withViewOutline = withBemMod<WithViewOutlineProps>(cnTag(), {
    view: 'outline',
});
